module.exports = __webpack_public_path__ + "assets/img/main-type-1.e31acc83.svg";